import { jsx as s, jsxs as C } from "react/jsx-runtime";
import * as r from "react";
import P from "embla-carousel-react";
import { ChevronLeft as S, ChevronRight as R } from "lucide-react";
import { cn as f } from "../../../lib/utils.js";
const h = r.createContext(null);
function d() {
  const o = r.useContext(h);
  if (!o)
    throw new Error("useCarousel must be used within a <Carousel />");
  return o;
}
const z = r.forwardRef(({ orientation: o = "horizontal", opts: l, setApi: t, plugins: a, className: c, children: i, ...x }, v) => {
  const [N, e] = P({
    ...l,
    axis: o === "horizontal" ? "x" : "y"
  }, a), [g, w] = r.useState(!1), [p, y] = r.useState(!1), u = r.useCallback((n) => {
    n && (w(n.canScrollPrev()), y(n.canScrollNext()));
  }, []), m = r.useCallback(() => {
    e == null || e.scrollPrev();
  }, [e]), b = r.useCallback(() => {
    e == null || e.scrollNext();
  }, [e]), k = r.useCallback((n) => {
    n.key === "ArrowLeft" ? (n.preventDefault(), m()) : n.key === "ArrowRight" && (n.preventDefault(), b());
  }, [m, b]);
  return r.useEffect(() => {
    !e || !t || t(e);
  }, [e, t]), r.useEffect(() => {
    if (e)
      return u(e), e.on("reInit", u), e.on("select", u), () => {
        e == null || e.off("select", u);
      };
  }, [e, u]), s(h.Provider, { value: {
    carouselRef: N,
    api: e,
    opts: l,
    orientation: o || ((l == null ? void 0 : l.axis) === "y" ? "vertical" : "horizontal"),
    scrollPrev: m,
    scrollNext: b,
    canScrollPrev: g,
    canScrollNext: p
  }, children: s("div", { ref: v, onKeyDownCapture: k, className: f("relative", c), role: "region", "aria-roledescription": "carousel", ...x, children: i }) });
});
z.displayName = "Carousel";
const j = r.forwardRef(({ className: o, ...l }, t) => {
  const { carouselRef: a, orientation: c } = d();
  return s("div", { ref: a, className: "overflow-hidden", children: s("div", { ref: t, className: f("flex", c === "horizontal" ? "-ml-4" : "-mt-4 flex-col", o), ...l }) });
});
j.displayName = "CarouselContent";
const D = r.forwardRef(({ className: o, ...l }, t) => {
  const { orientation: a } = d();
  return s("div", { ref: t, role: "group", "aria-roledescription": "slide", className: f("min-w-0 shrink-0 grow-0 basis-full", a === "horizontal" ? "pl-4" : "pt-4", o), ...l });
});
D.displayName = "CarouselItem";
const E = r.forwardRef(({ className: o, ...l }, t) => {
  const { orientation: a, scrollPrev: c, canScrollPrev: i } = d();
  return C("button", { ref: t, className: f("absolute h-10 w-10 rounded-full border border-[var(--border-color)] bg-[var(--bg-surface)] flex items-center justify-center disabled:cursor-not-allowed disabled:opacity-50 transition-colors hover:bg-[var(--bg-muted)] focus:outline-none focus:ring-lpr-teal dark:focus:ring-lpr-gold focus:ring-offset-2", a === "horizontal" ? "-left-12 top-1/2 -translate-y-1/2" : "-top-12 left-1/2 -translate-x-1/2 rotate-90", o), disabled: !i, onClick: c, ...l, children: [s(S, { className: "h-5 w-5 text-lpr-teal dark:text-lpr-gold" }), s("span", { className: "sr-only", children: "Previous slide" })] });
});
E.displayName = "CarouselPrevious";
const I = r.forwardRef(({ className: o, ...l }, t) => {
  const { orientation: a, scrollNext: c, canScrollNext: i } = d();
  return C("button", { ref: t, className: f("absolute h-10 w-10 rounded-full border border-[var(--border-color)] bg-[var(--bg-surface)] flex items-center justify-center disabled:cursor-not-allowed disabled:opacity-50 transition-colors hover:bg-[var(--bg-muted)] focus:outline-none focus:ring-lpr-teal dark:focus:ring-lpr-gold focus:ring-offset-2", a === "horizontal" ? "-right-12 top-1/2 -translate-y-1/2" : "-bottom-12 left-1/2 -translate-x-1/2 rotate-90", o), disabled: !i, onClick: c, ...l, children: [s(R, { className: "h-5 w-5 text-lpr-teal dark:text-lpr-gold" }), s("span", { className: "sr-only", children: "Next slide" })] });
});
I.displayName = "CarouselNext";
export {
  z as Carousel,
  j as CarouselContent,
  D as CarouselItem,
  I as CarouselNext,
  E as CarouselPrevious
};
//# sourceMappingURL=Carousel.js.map
